<!-- [ngClass]="isDropdownOpen ? 'search-input-wrapper--shadow':''" -->
<div class="container mt-3">
  <div class="search-input-wrapper" [ngClass]="width ? 'width-75':'w-100'">
    <div class="search-wrap w-100 position-relative">
      <span
        [innerHTML]="searchIconSVG | safeHTML"
        class="position-absolute search-icon d-flex align-items-center"
      ></span>
      <!-- (keyup.enter)="enterSearchKeywords($event)" -->
      <input
      #searchtext
        type="text"
        class="w-100 form-control"
        placeholder="{{'global-search.type-to-search' | translate}}"
        [formControl]="search"
        (keyup.enter)="enteredSearchResult(searchtext.value)"
        (keyup)="onKeyup($event)"
        (focus)="focusEvent.emit(true)"
        (focusout)="focusEvent.emit(false)"
      />
      <div class="close position-absolute cursor-pointer">
        <img
          src="https://media.umangapp.in/cdn/landing/close.svg"
          alt="close"
          width="16px"
          height="16px"
          *ngIf="search.value"
          (click)="closeSuggestion()"
          class="light-mode-umg"
        />
        <img
          src="https://media.umangapp.in/cdn/landing/close-light.svg"
          alt="close"
          width="16px"
          height="16px"
          *ngIf="search.value"
          (click)="closeSuggestion()"
          class="dark-mode-umg"
        />
      </div>
    </div>

    <!-- *ngIf="suggesion" -->

    <!-- <div class="search-results" [ngClass]="(suggesion && isSuggestedResult) ? 'search-results--shadow search-results--show':''">
      <ng-container *ngIf="search.value">
        <h4 class="search-heading" *ngIf="keySearchResultRes.length">Suggestion</h4>
        <ul class="search-list">
          <ng-container *ngIf="isSuggestedResult;">
            <li
            *ngFor="let item of keySearchResultRes"
            (click)="navigateToDept(item?.alises)"
            role="button"
          >
            {{ item?.alises }}
          </li>
          </ng-container>
        </ul>
      </ng-container>
    </div> -->
  </div>
</div>
